import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getCurrentDateTime } from '@/utils/getCurrentDateTime';
import { faShare, faReply, faRotate } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DonutChart from './DonutChart/DonutChart';
import ProgressBarMon from './ProgressBar/ProgressBar';
import styles from './PrivateStopovers.module.scss';
import { Schedule } from '../Schedule/getBuque';
import Button from '../Button/Button';

type PrivateStopoversPros = {
  data?: Schedule;
  onUpdate?: () => void;
  operaciones?: string;
};

const PrivateStopovers: FC<PrivateStopoversPros> = ({
  data,
  onUpdate = () => {},
  operaciones,
}) => {
  const { t } = useTranslation('privateStopovers');
  const lastUpdate = getCurrentDateTime();

  const isStarted = useMemo(() => {
    const now = new Date();
    const start = new Date(operaciones || '');
    return now.getTime() > start.getTime();
  }, [operaciones]);

  const porcentajeCarga = Number(
    (
      ((data?.totalCargaProcesada || 0) * 100) /
      (data?.totalCarga || 1)
    ).toFixed(2)
  );
  const porcentajeDescarga = Number(
    (
      ((data?.totalDescargaProcesada || 0) * 100) /
      (data?.totalDescarga || 1)
    ).toFixed(2)
  );
  if (!isStarted) {
    return (
      <div className="h-10rem	flex justify-content-center align-items-center w-full">
        <p className="font-bold text-xl">{t('legend')}</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.lastUpdate}>
        <div className={styles.containerTop} />

        <div className={styles.containerUpdate}>
          <div className={styles.containerLast}>
            <p>{`${t('lastUpdate')}:`}</p>
            <b style={{ textWrap: 'nowrap' }}>{lastUpdate}</b>
          </div>
          <Button text className={styles.updateButton} onClick={onUpdate}>
            <FontAwesomeIcon icon={faRotate} />
            {t('update')}
          </Button>
        </div>
      </div>
      <div className={styles.containerAllChart}>
        <div className={styles.containerChart}>
          <div className={styles.containerTitle}>
            <div className={styles.containerIcon}>
              <FontAwesomeIcon icon={faReply} color="#223466" />
              <div className={styles.text}>{t('titleCarga')}</div>
            </div>

            <div className={styles.subTitle}>
              <span style={{ fontWeight: 700 }}>
                {data?.totalCargaProcesada}
              </span>
              {`/${data?.totalCarga} ${t('processed')}`}
            </div>
          </div>

          <ProgressBarMon value={porcentajeCarga} />
          <DonutChart data={data} type="carga" />
        </div>
        <div className={styles.containerChart}>
          <div className={styles.containerTitle}>
            <div className={styles.containerIcon}>
              <FontAwesomeIcon icon={faShare} color="#223466" />
              <div className={styles.text}>{t('titleDescarga')}</div>
            </div>
            <div className={styles.subTitle}>
              <span style={{ fontWeight: 700 }}>
                {data?.totalDescargaProcesada}
              </span>
              {`/${data?.totalDescarga} ${t('processed')}`}
            </div>
          </div>

          <ProgressBarMon value={porcentajeDescarga} />
          <DonutChart data={data} type="descarga" />
        </div>
      </div>
    </div>
  );
};

export default PrivateStopovers;
